export var JUST_ME = "private";
export var MY_FEED = "teams";
export var EVERYTHING = "";
export var SORT_OPTIONS = [
    { value: EVERYTHING, label: "recognition.polls.filters.sortBy.options.everything" },
    { value: MY_FEED, label: "recognition.polls.filters.sortBy.options.myTeams" },
    { value: JUST_ME, label: "recognition.polls.filters.sortBy.options.justMe" }
];
export default {
    JUST_ME: JUST_ME,
    MY_FEED: MY_FEED,
    EVERYTHING: EVERYTHING,
    OPTIONS: SORT_OPTIONS
};
